import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-241" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-242" data-mp="3fxkx4ig9ujno">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-243" data-mp="3b1chl3y5wofz">
          Testimonios de docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-244" data-mp="3205z4pbyd3k3">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-line bg-panel p-6 text-ink shadow-card" data-id="element-245" data-mp="2x1ur8k57x34i" data-mpi={index}>
              <div className="flex text-gold" aria-label="5 de 5 estrellas" data-id="element-246" data-mp="h55aw37q1xxm">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-247" data-mp="m2ood0wli6oi" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-248" data-mp="c6bua1x51qt8">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-249" data-mp="zvwgqusi3679">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-skyDeep text-sm font-extrabold text-white" data-id="element-250" data-mp="14v9be1pm5hke">
                  {initials}
                </span>
                <span data-id="element-251" data-mp="v5g071tdv4go">
                  <b className="block text-sm text-ink" data-id="element-252" data-mp="v4xvdgsnnhx5">{name}</b>
                  <small className="text-xs text-muted" data-id="element-253" data-mp="1ivae7mpfuz2i">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}